import React from "react";
import Link from "next/link";
import FooterNewsletter from "./footerNewsletter/FooterNewsletter";
import FooterSitemap from "./footerSitemap/FooterSitemap";
import { withTranslation } from "../../i18n";
import css from "./Footer.module.scss";

const namespacesRequired = ["footer"];

function Footer({ t }) {
  const googleReviewsImage = "/static/images/footer/google-review.png";
  const trustpilotImage = "/static/images/participation/trustpilot.webp";

  const trustpilotHref = "https://fr.trustpilot.com/evaluate/milleetunelistes.fr";
  const googleReviewsHref =
    "https://search.google.com/local/writereview?placeid=ChIJx5wPn--E3gYRULA_7OVw_BE";

  return (
    <footer id="footer" className={css.footer}>
      <div className={css.content}>
        <FooterNewsletter />
        <FooterSitemap />
      </div>
      <div className={css.divider} aria-hidden="true" />
      <div className={css.bottom}>
        <nav className={css.keywords} aria-label={t("footer:keywords-label")}>
          <Link href="/actualites/actualites/dw6St1dG-5-bonnes-raisons-de-faire-une-liste-de-mariage-et-pourquoi-vous-allez-ladorer">
            {t("footer:keywords.list")}
          </Link>
          <span className={css.keywordSeparator} aria-hidden="true">
            {" - "}
          </span>
          <Link href="/comment-ca-marche">
            {t("footer:keywords.pot")}
          </Link>
          <span className={css.keywordSeparator} aria-hidden="true">
            {" - "}
          </span>
          <Link href="/voyage-de-noces">
            {t("footer:keywords.travel")}
          </Link>
          <span className={css.keywordSeparator} aria-hidden="true">
            {" - "}
          </span>
          <Link href="/gifts">
            {t("footer:keywords.gifts")}
          </Link>
        </nav>
        <div className={css.trust}>
          <a href={googleReviewsHref} target="_blank" rel="noreferrer">
            <img
              className={css.googleReviews}
              src={googleReviewsImage}
              alt="Google reviews"
            />
          </a>
          <a href={trustpilotHref} target="_blank" rel="noreferrer">
            <div className={css.trustBox}>
              <span className={css.trustLabel}>{t("footer:trust-label")}</span>
              <img
                className={css.trustLogo}
                src={trustpilotImage}
                alt="Trustpilot"
              />
            </div>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default withTranslation(namespacesRequired)(Footer);
